import React, { Component } from 'react';

import Data from '../_core/models/Data'
import Entry from '../_core/models/Entry';
import Link from '../_core/components/Link';
import Content from '../_core/components/Content';
import Gallery from '../_core/components/Gallery';
import Image from '../_core/components/Image';
import SiteModifier from '../_core/components/SiteModifier';
import Icon from '../_core/components/Icon';

import Container from '../components/Container';
import CarouselGallery from '../components/CarouselGallery';

const IS_TOUCH = 'ontouchstart' in window || navigator.msMaxTouchPoints;

// Store current slide index across pages
window.SLIDE_IX = 0; // -1 as a start so we know it hasn't initialised yet

class Index extends Component {

	slider = null;
  	cur = 0;

	constructor(props) {
		super(props);
		this.state = {slide:window.SLIDE_IX}
	}

	componentDidMount() {

	}

	componentWillUnmount() {

	}

	initSlider = (slider) => {
  		this.slider = slider;
  		//this.goTo(0);
	}

	changedSlide = ({slide}) => {

		
		this.setState({slide:slide});

	}

	/*

		RENDER

	*/

	render() {

		let {entry} = this.props;

		let initialSlide = window.SLIDE_IX;

		return (
			<div className="Template Template--index">

			
			<div className="Template-gallery">


				{(()=>{

					if(IS_TOUCH || (window.innerWidth < 700)){
						return (
							<React.Fragment>
								<Data require={['HOME']}>
				  					{({entries})=>{

				      					let projects = entry.projects.map(id => entries.find(e => (e.id == id)));

										return (<React.Fragment><CarouselGallery onChange={(ix)=>this.changedSlide({slide:ix})} settings={{initialSlide:initialSlide}} api={this.initSlider}>
											{
												projects.map(
													(i,ix) => (
														<div className="Gallery-slide" key={'img_'+ix+i.lead_image}>
														<div className="Gallery-image">
								                        <Link to={i.uri}>{i.data.lead_image && <Image src={i.data.lead_image.url}  fluid={true} lazy={true} />}</Link>
								                        <Link className="Gallery-hidden-link" to={i.uri}>{i.title}</Link>
								                      	</div>
								                      	</div>
													)
												)
											}
										</CarouselGallery>
										<div className="Template-project-titles">
											{projects.map(
													(i,ix) => (
														<div className={`Template-project-title ${(ix == this.state.slide) ? 'active' : 'inactive'}`} key={'img_'+ix}>
														
								                        <Link className="Template-project-link" to={i.uri}>{i.title}</Link>
								                      	</div>
								                      	
													)
												)}
										</div>
										</React.Fragment>)
									}}
								</Data>
							</React.Fragment>
						)
					}else{

						return (
							<Container>
				<SiteModifier hover hovermodifier={'cursor'}>
				<div className="Template-gallery-cursor-target">

				<Data require={['HOME']}>
				  {({entries,SHOWINFO})=>{

				      let projects = entry.projects.map(id => entries.find(e => (e.id == id)));

				      return <Gallery 
				      	modifier="slides"
						prev={

							<SiteModifier hover hovermodifier={'cursorLeft'}><div className="Gallery-cursor-target" /></SiteModifier>

						}

						next={

							<SiteModifier hover hovermodifier={'cursorRight'}><div className="Gallery-cursor-target" /></SiteModifier>

						}

						autoplayoff wait={500} delay={2000} slidesToLoad={2} initialSlide={initialSlide} onChange={(ix)=>this.changedSlide({slide:ix})} items={projects} getItem={(i,ix,active)=>{

							
		                  return (
		                  
		                      <div className="Gallery-slide" key={'img_'+ix+i.lead_image}>
		                        <div className="Gallery-hotspot"><SiteModifier hover hovermodifier={'click'}><div><Link to={i.uri}><span>{i.title}</span></Link></div></SiteModifier></div>
		                        <Link to={i.uri}>{i.data.lead_image && <Image src={i.data.lead_image.url}  fluid={true} lazy={true} />}</Link>
		                        <div className="Gallery-link"><SiteModifier hover hovermodifier={'click'}><span><Link className={active ? 'active' : 'inactive'} to={i.uri}>{i.title}</Link></span></SiteModifier></div>
		                      </div>
		                    
		                  )
		                }} />
				  }}
				</Data>

				
				
                </div>
                </SiteModifier>
                </Container>
						)

					}

				})()}

				
			</div>
			

			<SiteModifier hovermodifier={'teaser'} hover={true}>
			<div className="Template-teaser">
				<Link to={'#/information/'} className="Template-teaser-link">Information</Link>
			</div>
			</SiteModifier>

			<Data require={['HOME']}>
				  {({SHOWINFO})=>{

				      return <div className="Template-touch-teaser-wrap"><span>Menu: </span><Link to={((SHOWINFO) ? '/' :'#/information/')} className="Template-touch-teaser-link"></Link></div>
				  }}
			</Data>

			<div className="Template-info" >
				<div className="Template-info-wash" style={{background:entry.data.information_colour}} />
				<div className="Template-info-content">
					<div className="Template-info-logo-hotspot"><Link to={entry.uri}><span>Back</span></Link></div>
					<div className="Template-info-close"><Link to={entry.uri}><Icon glyph type={'cross'} /></Link></div>
					<div className="Template-info-scroll">
					<div className="Template-info-text">

						<div className="Template-info--small">
						<div className="Content Content--large">
							<div>{entry.data.contact_1}</div>
							<div>{entry.data.contact_2}</div>
							<div>{entry.data.contact_3}</div>
						</div>
						<Content html={entry.contact} />
						</div>

						<Content html={entry.information} />

						<Content>
							{/*
							<h3>{entry.data.clients_heading}</h3>
							<Gallery modifier="inline" autoplay delay={2000} wait={500} items={entry.data.clients.shuffle()} getItem={(item) => <div className="Gallery-statement">{item.text}</div>} />
							*/}

							<h3>{entry.data.clients_heading}</h3>
							<ul className="List List--clients">
								{entry.data.clients.map((c,ix) =>
									<li key={`client${ix}`}>{c.text}</li>
								)}
							</ul>

						
							
							{/*

							<h3>{entry.data.collaborators_heading}</h3>
							<Gallery modifier="inline" autoplay delay={2000} wait={0} items={entry.data.collaborators.shuffle()} getItem={(item) => <div className="Gallery-statement">{item.text}</div>} />
							
							<h3>{entry.data.people_heading}</h3>
							<Gallery modifier="inline" autoplay delay={2000} wait={1000} items={entry.data.people.shuffle()} getItem={(item) => <div className="Gallery-statement">{item.text}</div>} />
							
							*/}

						</Content>

						<div className="Template-info--contact">
						<Content html={entry.contact} />
						</div>

						<div className="Template-info--credit">
						<Content>
							

						
							<ul>
								<li>Site design: <a href="https://e-i-b.com">Everything In Between</a></li>
								<li>Build: <a href="https://un-work.co">un—work</a></li>
							</ul>
							
							{/*

							<h3>{entry.data.collaborators_heading}</h3>
							<Gallery modifier="inline" autoplay delay={2000} wait={0} items={entry.data.collaborators.shuffle()} getItem={(item) => <div className="Gallery-statement">{item.text}</div>} />
							
							<h3>{entry.data.people_heading}</h3>
							<Gallery modifier="inline" autoplay delay={2000} wait={1000} items={entry.data.people.shuffle()} getItem={(item) => <div className="Gallery-statement">{item.text}</div>} />
							
							*/}

						</Content>
						</div>
				</div>
				</div>
				</div>
				<div className="Template-info-foot"><Container>
					<div data-grid-of="3" data-mobile-grid-of="4">
						<div>{entry.data.contact_1}</div>
						<div data-mobile-two-of="4">{entry.data.contact_2}</div>
						<div>{entry.data.contact_3}</div>
					</div>
				</Container></div>
			</div>

			</div>
		);

	}
}

export default Index;



// WEBPACK FOOTER //
// ./src/js/templates/index.js